module.exports = __webpack_public_path__ + "static/media/checkstyle04.dac41033.png";